
import { FeatureId } from '@/contexts/FeatureModelContext';

/**
 * Model settings for each feature
 * This is the single source of truth for which model is used for each feature
 */
export const MODEL_SETTINGS: Record<FeatureId, string> = {
  deepAnalysis: 'gpt-4o-mini',
  recommended: 'gpt-4o',
  sitemap: 'gpt-4o-mini',
  faqSerp: 'gpt-4o',
  ecoAssistant: 'gpt-4o'
};

/**
 * Temperature settings for each feature
 */
export const TEMPERATURE_SETTINGS: Record<FeatureId, number> = {
  deepAnalysis: 0.2,
  recommended: 0.7,
  sitemap: 0.1,
  faqSerp: 0.7,
  ecoAssistant: 0.4
};

/**
 * Max tokens settings for each feature
 */
export const MAX_TOKENS_SETTINGS: Record<FeatureId, number> = {
  deepAnalysis: 2000,
  recommended: 2500,
  sitemap: 1500,
  faqSerp: 2500,
  ecoAssistant: 2000
};

/**
 * Response format preference for each feature
 */
export const RESPONSE_FORMAT_SETTINGS: Record<FeatureId, 'json_object' | 'text'> = {
  deepAnalysis: 'json_object',
  recommended: 'json_object',
  sitemap: 'json_object',
  faqSerp: 'json_object',
  ecoAssistant: 'text'
};
